import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'sl-accordion-section',
  templateUrl: './accordion-section.component.html'
})
export class AccordionSectionComponent implements OnInit {
  @Input() public title: string;
  public sectionId: string;

  constructor() { }

  ngOnInit() {
    // random id for collapsing section based on the title text
    this.sectionId = this.title.replace(/\s/g, '') + Math.random().toString(36).substr(2, 5);
  }
}
